import React from 'react';
import Header from '../../Components/Header';
import ModifySearch from './ModifySearch';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const Results = () => {
    return (
        <>
            <Header></Header>
            <ModifySearch />
            <section className='Results_hotel'>
                <div className='row'>
                    <div className='col-md-3 col-lg-3'>
                        <div className='box_shadow'>
                            <div class="accordion" id="kt_accordion_1">
                                <div class="accordion-item">
                                <h2 class="accordion-header" id="kt_accordion_1_header_1">
                                    <button class="accordion-button fs-4 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_1" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                                        Price
                                    </button>
                                </h2>
                                <div id="kt_accordion_1_body_1" class="accordion-collapse collapse show" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                                    <div class="accordion-body">
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultInr" />
                                                <label class="form-check-label" for="flexCheckDefaultInr">
                                                    <i className='fa fa-inr'></i> 1 - <i className='fa fa-inr'></i> 2,000
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultInr1" />
                                                <label class="form-check-label" for="flexCheckDefaultInr1">
                                                    <i className='fa fa-inr'></i> 2,001 - <i className='fa fa-inr'></i> 4,000
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultInr2" />
                                                <label class="form-check-label" for="flexCheckDefaultInr2">
                                                    <i className='fa fa-inr'></i> 4,001 - <i className='fa fa-inr'></i> 8,000
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultInr3" />
                                                <label class="form-check-label" for="flexCheckDefaultInr3">
                                                    <i className='fa fa-inr'></i> 8,001 - <i className='fa fa-inr'></i> 20,000
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultInr4" />
                                                <label class="form-check-label" for="flexCheckDefaultInr4">
                                                    <i className='fa fa-inr'></i> 20,001 - <i className='fa fa-inr'></i> 30,000
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultInr5" />
                                                <label class="form-check-label" for="flexCheckDefaultInr5">
                                                    Above <i className='fa fa-inr'></i> 30,000
                                                </label>
                                            </div>
                                    </div>
                                </div>
                            </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="kt_accordion_1_header_2">
                                        <button class="accordion-button fs-4 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_2" aria-expanded="false" aria-controls="kt_accordion_1_body_2">
                                            Star Rating
                                        </button>
                                    </h2>
                                    <div id="kt_accordion_1_body_2" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_2" data-bs-parent="#kt_accordion_1">
                                        <div class="accordion-body">
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault5" />
                                                <label class="form-check-label" for="flexCheckDefault5">
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault4" />
                                                <label class="form-check-label" for="flexCheckDefault4">
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault3" />
                                                <label class="form-check-label" for="flexCheckDefault3">
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault2" />
                                                <label class="form-check-label" for="flexCheckDefault2">
                                                    <i class="star"></i>
                                                    <i class="star"></i>
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault1" />
                                                <label class="form-check-label" for="flexCheckDefault1">
                                                    <i class="star"></i>
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="kt_accordion_1_header_3">
                                        <button class="accordion-button fs-4 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_3" aria-expanded="false" aria-controls="kt_accordion_1_body_3">
                                            Cancellation Type
                                        </button>
                                    </h2>
                                    <div id="kt_accordion_1_body_3" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_3" data-bs-parent="#kt_accordion_1">
                                        <div class="accordion-body">
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefault13" />
                                                <label class="form-check-label" for="flexCheckDefault13">
                                                    Non Refundable
                                                </label>
                                            </div>

                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckChecked2" />
                                                <label class="form-check-label" for="flexCheckChecked2">
                                                    Refundable
                                                </label>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="kt_accordion_1_header_4">
                                        <button class="accordion-button fs-4 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_4" aria-expanded="false" aria-controls="kt_accordion_1_body_4">
                                            Meal Type
                                        </button>
                                    </h2>
                                    <div id="kt_accordion_1_body_4" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_4" data-bs-parent="#kt_accordion_1">
                                        <div class="accordion-body">
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultA" />
                                                <label class="form-check-label" for="flexCheckDefaultA">
                                                    Breakfast For 2
                                                </label>
                                            </div>

                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckeB" />
                                                <label class="form-check-label" for="flexCheckCheckeB">

                                                    Room Only
                                                </label>
                                            </div>

                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedC" />
                                                <label class="form-check-label" for="flexCheckCheckedC">

                                                    Breakfast
                                                </label>
                                            </div>

                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedD" />
                                                <label class="form-check-label" for="flexCheckCheckedD">

                                                    Dinner
                                                </label>
                                            </div>

                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedE" />
                                                <label class="form-check-label" for="flexCheckCheckedE">

                                                    All Inclusive All Meal
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="kt_accordion_1_header_5">
                                        <button class="accordion-button fs-4 fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_5" aria-expanded="false" aria-controls="kt_accordion_1_body_5">
                                            Show Hotels With
                                        </button>
                                    </h2>
                                    <div id="kt_accordion_1_body_5" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_5" data-bs-parent="#kt_accordion_1">
                                        <div class="accordion-body">
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckDefaultArrival" />
                                                <label class="form-check-label" for="flexCheckDefaultArrival">
                                                    welcome Drink On Arrival
                                                </label>
                                            </div>

                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedParking" />
                                                <label class="form-check-label" for="flexCheckCheckedParking">
                                                    Free Valet Parking
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedSelf" />
                                                <label class="form-check-label" for="flexCheckCheckedSelf">
                                                    Free Self Parking
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedOnly" />
                                                <label class="form-check-label" for="flexCheckCheckedOnly">
                                                    Room Only
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedWifi" />
                                                <label class="form-check-label" for="flexCheckCheckedWifi">
                                                    Free Wifi
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedUpgrade" />
                                                <label class="form-check-label" for="flexCheckCheckedUpgrade">
                                                    Free Room Upgrade
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedTo" />
                                                <label class="form-check-label" for="flexCheckCheckedTo">
                                                    late Check-out Upto 2 Hours (subject To Availability)
                                                </label>
                                            </div>
                                            <div class="form-check w-100">
                                                <input class="form-check-input" type="checkbox" defaultValue="" id="flexCheckCheckedsubject" />
                                                <label class="form-check-label" for="flexCheckCheckedsubject">
                                                    early Check-in Upto 2 Hours (subject To Availability)
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='col-md-9 col-lg-9'>
                        <div className='box_shadow_wbg'>
                            <div class="row ruslt_sort">
                                <div class="col-md-12 col-lg-12">
                                    <h3 class="destnation">Delhi NCR (1 Nights)
                                        <i class="fa fa-arrow-right"></i>
                                        <small>Thu , 18 Sep - Fri , 19 Sep | 1 Room, 2 Adult</small>
                                    </h3>
                                </div>
                            </div>

                            <div className='repeat_hotel'>
                                <div className='row'>
                                    <div className='col-md-4 col-lg-4'>
                                        <div className='hotrl_img'>
                                            <img src='/assets/images/hotel/hotel.jpg' className='img-full' alt='hotel' />
                                            <a className='viewDetails' href='' data-bs-toggle="modal" data-bs-target="#hotlDetail">Detail View</a>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='name_Address'>
                                            <h4>Hotel Picasso</h4>
                                             <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                            <p className='loction'><i className='fa fa-location-dot'></i>
                                                B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>
                                       
                                            <ul className='availble'>
                                                <li><img src='/assets/images/hotel/breakfast.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/car-parking.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/wifi.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/gym.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/swimming.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/spa.png' alt="flight"/></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-md-3 col-lg-3'>
                                        <div className='price_views'>
                                            <p className='room_only'>Room Only</p>
                                            <p className='per_day'>Price For 1 Night</p>
                                            <h2 className='price'><i className='fa fa-inr'></i>45258 </h2>
                                            <p className='taxes'>Includes Taxes & Charges</p>
                                            <a className='choose_room' href='/hotel/hoteldetail'>Chose Room</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className='repeat_hotel'>
                                <div className='row'>
                                    <div className='col-md-4 col-lg-4'>
                                        <div className='hotrl_img'>
                                            <img src='/assets/images/hotel/hotel-1.jpg' className='img-full' alt='hotel' />
                                            <a className='viewDetails' href='' data-bs-toggle="modal" data-bs-target="#hotlDetail">Detail View</a>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='name_Address'>
                                            <h4>Hotel Picasso</h4>
                                             <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                            <p className='loction'><i className='fa fa-location-dot'></i>
                                                B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>

                                            <ul className='availble'>
                                                <li><img src='/assets/images/hotel/breakfast.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/car-parking.png' alt="flight" /></li>
                                                <li><img src='/assets/images/hotel/wifi.png' alt="flight" /></li>
                                                <li><img src='/assets/images/hotel/gym.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/swimming.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/spa.png' alt="flight"/></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-md-3 col-lg-3'>
                                        <div className='price_views'>
                                            <p className='room_only'>Room Only</p>
                                            <p className='per_day'>Price For 1 Night</p>
                                            <h2 className='price'><i className='fa fa-inr'></i>45258 </h2>
                                            <p className='taxes'>Includes Taxes & Charges</p>
                                            <a className='choose_room' href='/hotel/hoteldetail'>Chose Room</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className='repeat_hotel'>
                                <div className='row'>
                                    <div className='col-md-4 col-lg-4'>
                                        <div className='hotrl_img'>
                                            <img src='/assets/images/hotel/hotel-2.jpg' className='img-full' alt='hotel' />
                                            <a className='viewDetails' href='' data-bs-toggle="modal" data-bs-target="#hotlDetail">Detail View</a>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='name_Address'>
                                            <h4>Hotel Picasso</h4>
                                             <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                            <p className='loction'><i className='fa fa-location-dot'></i>
                                                B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>

                                            <ul className='availble'>
                                                <li><img src='/assets/images/hotel/breakfast.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/car-parking.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/wifi.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/gym.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/swimming.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/spa.png' alt="flight"/></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-md-3 col-lg-3'>
                                        <div className='price_views'>
                                            <p className='room_only'>Room Only</p>
                                            <p className='per_day'>Price For 1 Night</p>
                                            <h2 className='price'><i className='fa fa-inr'></i>45258 </h2>
                                            <p className='taxes'>Includes Taxes & Charges</p>
                                            <a className='choose_room' href='/hotel/hoteldetail'>Chose Room</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className='special_delas'>
                                <h5 className='Collections'><i class="star"></i> Collections</h5>
                                 <Swiper
                                            modules={[Navigation, Autoplay]}
                                            spaceBetween={10}
                                            slidesPerView={4}
                                            navigation
                                            autoplay={{ delay: 332000 }}
                                            loop={true}>
                                <SwiperSlide>
                                <div className='box_iten'>
                                    <div className='box_item_img'>
                                        <img className='img-full' src='/assets/images/hotel/small-hotel.jpg' alt='hotel' />
                                    </div>
                                    <div className='box_item_text'>
                                        <h4>Beach Paradise</h4>
                                        <p>Classic beach experience with access to sandy shores and vibrant beach activities</p>
                                    </div>
                                </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                <div className='box_iten'>
                                    <div className='box_item_img'>
                                        <img className='img-full' src='/assets/images/hotel/small-hotel-1.jpg' alt='hotel' />
                                    </div>
                                    <div className='box_item_text'>
                                        <h4>Adventure Hubs</h4>
                                        <p>Enjoy the thrill with stays near best adventure &amp; water sports hubs</p>
                                    </div>
                                </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                <div className='box_iten'>
                                    <div className='box_item_img'>
                                        <img className='img-full' src='/assets/images/hotel/small-hotel-2.jpg' alt='hotel' />
                                    </div>
                                    <div className='box_item_text'>
                                        <h4>Luxury Retreats</h4>
                                        <p>Engaging experiences and world-class amenities for an ultimate luxury experience</p>
                                    </div>
                                </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                <div className='box_iten'>
                                    <div className='box_item_img'>
                                        <img className='img-full' src='/assets/images/hotel/small-hotel-3.jpg' alt='hotel' />
                                    </div>
                                    <div className='box_item_text'>
                                        <h4>Party Central</h4>
                                        <p>Vibrant nightlife and beach parties for party enthusiasts</p>
                                    </div>
                                </div>
                                 </SwiperSlide>
                                <SwiperSlide>
                                <div className='box_iten'>
                                    <div className='box_item_img'>
                                        <img className='img-full' src='/assets/images/hotel/small-hotel-4.jpg' alt='hotel' />
                                    </div>
                                    <div className='box_item_text'>
                                        <h4>Peaceful Escapes</h4>
                                        <p>Peaceful and secluded escapes away from tourist crowds</p>
                                    </div>
                                </div>
                                 </SwiperSlide>
                                <SwiperSlide>
                                <div className='box_iten'>
                                    <div className='box_item_img'>
                                        <img className='img-full' src='/assets/images/hotel/small-hotel-5.jpg' alt='hotel' />
                                    </div>
                                    <div className='box_item_text'>
                                        <h4>Getaway Homes</h4>
                                        <p>Spacious homes with engaging activities, perfect to spend quality time with your group</p>
                                    </div>
                                </div>
                                 </SwiperSlide>
</Swiper>

                            </div>


                            <div className='repeat_hotel'>
                                <div className='row'>
                                    <div className='col-md-4 col-lg-4'>
                                        <div className='hotrl_img'>
                                            <img src='/assets/images/hotel/hotel-3.jpg' className='img-full' alt='hotel' />
                                            <a className='viewDetails' href='' data-bs-toggle="modal" data-bs-target="#hotlDetail">Detail View</a>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='name_Address'>
                                            <h4>Hotel Picasso</h4>
                                             <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                            <p className='loction'><i className='fa fa-location-dot'></i>
                                                B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>

                                            <ul className='availble'>
                                                <li><img src='/assets/images/hotel/breakfast.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/car-parking.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/wifi.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/gym.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/swimming.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/spa.png' alt="flight"/></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-md-3 col-lg-3'>
                                        <div className='price_views'>
                                            <p className='room_only'>Room Only</p>
                                            <p className='per_day'>Price For 1 Night</p>
                                            <h2 className='price'><i className='fa fa-inr'></i>45258 </h2>
                                            <p className='taxes'>Includes Taxes & Charges</p>
                                            <a className='choose_room' href='/hotel/hoteldetail'>Chose Room</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className='repeat_hotel'>
                                <div className='row'>
                                    <div className='col-md-4 col-lg-4'>
                                        <div className='hotrl_img'>
                                            <img src='/assets/images/hotel/hotel-4.jpg' className='img-full' alt='hotel' />
                                            <a className='viewDetails' href='' data-bs-toggle="modal" data-bs-target="#hotlDetail">Detail View</a>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='name_Address'>
                                            <h4>Hotel Picasso</h4>
                                             <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                            <p className='loction'><i className='fa fa-location-dot'></i>
                                                B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>

                                            <ul className='availble'>
                                                <li><img src='/assets/images/hotel/breakfast.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/car-parking.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/wifi.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/gym.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/swimming.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/spa.png' alt="flight"/></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-md-3 col-lg-3'>
                                        <div className='price_views'>
                                            <p className='room_only'>Room Only</p>
                                            <p className='per_day'>Price For 1 Night</p>
                                            <h2 className='price'><i className='fa fa-inr'></i>45258 </h2>
                                            <p className='taxes'>Includes Taxes & Charges</p>
                                            <a className='choose_room' href='/hotel/hoteldetail'>Chose Room</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className='repeat_hotel'>
                                <div className='row'>
                                    <div className='col-md-4 col-lg-4'>
                                        <div className='hotrl_img'>
                                            <img src='/assets/images/hotel/hotel-5.jpg' className='img-full' alt='hotel' />
                                            <a className='viewDetails' href='' data-bs-toggle="modal" data-bs-target="#hotlDetail">Detail View</a>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='name_Address'>
                                            <h4>Hotel Picasso</h4>
                                             <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                            <p className='loction'><i className='fa fa-location-dot'></i>
                                                B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>

                                            <ul className='availble'>
                                                <li><img src='/assets/images/hotel/breakfast.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/car-parking.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/wifi.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/gym.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/swimming.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/spa.png' alt="flight"/></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-md-3 col-lg-3'>
                                        <div className='price_views'>
                                            <p className='room_only'>Room Only</p>
                                            <p className='per_day'>Price For 1 Night</p>
                                            <h2 className='price'><i className='fa fa-inr'></i>45258 </h2>
                                            <p className='taxes'>Includes Taxes & Charges</p>
                                            <a className='choose_room' href='/hotel/hoteldetail'>Chose Room</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className='repeat_hotel'>
                                <div className='row'>
                                    <div className='col-md-4 col-lg-4'>
                                        <div className='hotrl_img'>
                                            <img src='/assets/images/hotel/hotel-6.jpg' className='img-full' alt='hotel' />
                                            <a className='viewDetails' href='' data-bs-toggle="modal" data-bs-target="#hotlDetail">Detail View</a>
                                        </div>
                                    </div>
                                    <div className='col-md-5 col-lg-5'>
                                        <div className='name_Address'>
                                            <h4>Hotel Picasso</h4>
                                             <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                            <p className='loction'><i className='fa fa-location-dot'></i>
                                                B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>

                                            <ul className='availble'>
                                                <li><img src='/assets/images/hotel/breakfast.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/car-parking.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/wifi.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/gym.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/swimming.png' alt="flight"/></li>
                                                <li><img src='/assets/images/hotel/spa.png' alt="flight"/></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='col-md-3 col-lg-3'>
                                        <div className='price_views'>
                                            <p className='room_only'>Room Only</p>
                                            <p className='per_day'>Price For 1 Night</p>
                                            <h2 className='price'><i className='fa fa-inr'></i>45258 </h2>
                                            <p className='taxes'>Includes Taxes & Charges</p>
                                            <a className='choose_room' href='/hotel/hoteldetail'>Chose Room</a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Model Pop Up */}
            <div class="modal fade" id="hotlDetail">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Hotel Name</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body">
                            <div className='row'>
                                <div className='col-md-8 col-lg-8'>
                                    <div className='imgSlider'>
                                        <Swiper
                                            modules={[Navigation, Autoplay]}
                                            spaceBetween={10}
                                            slidesPerView={1}
                                            navigation
                                            autoplay={{ delay: 2000 }}
                                            loop={true}>
                                            <SwiperSlide>
                                                <div className='imager'>
                                                    <img src='/assets/images/hotel/hotel.jpg' className='img-full' alt='hotel' />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='imager'>
                                                    <img src='/assets/images/hotel/hotel-2.jpg' className='img-full' alt='hotel' />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='imager'>
                                                    <img src='/assets/images/hotel/hotel-3.jpg' className='img-full' alt='hotel' />
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='imager'>
                                                    <img src='/assets/images/hotel/hotel-4.jpg' className='img-full' alt='hotel' />
                                                </div>
                                            </SwiperSlide>
                                        </Swiper>

                                    </div>
                                </div>
                                <div className='col-md-4 col-lg-4'>
                                    <div className='contnt mt-5'>
                                        <h3 className='htl_name'>Park Residency</h3>
                                         <div className='start_cat'>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                            <i class="star"></i>
                                        </div>
                                        <p className='htl_add'>D-1, Green Park (Near Uphaar Cinema), Ashirwad Building, South DelhiNew Delhi 110016Delhi, , New Delhi</p>
                                       
                                        <ul class="availble">
                                            <li><img src="/assets/images/hotel/breakfast.png" alt='hotel' /></li>
                                            <li><img src="/assets/images/hotel/car-parking.png" alt='hotel' /></li>
                                            <li><img src="/assets/images/hotel/wifi.png" alt='hotel' /></li>
                                            <li><img src="/assets/images/hotel/gym.png" alt='hotel' /></li>
                                            <li><img src="/assets/images/hotel/swimming.png" alt='hotel' /></li>
                                            <li><img src="/assets/images/hotel/spa.png" alt='hotel' /></li>
                                            </ul>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='content'>
                                        <h3 className='sub_heading'>Overview</h3>
                                        <p>HeadLine : In New Delhi (Green Park)</p>
                                        <p>Location : With a stay at Hotel Park Residency in New Delhi (Green Park), you ll be a 4-minute drive from Sarojini Nagar Market and 6 minutes from Qutub Minar. This hotel is 4.4 mi (7.1 km) from India Gate and 7.7 mi (12.5 km) from Jama Masjid.</p>
                                        <p>Rooms : Make yourself at home in one of the 20 guestrooms featuring minibars and LCD televisions. Your room comes with a memory foam bed. Complimentary wireless internet access keeps you connected, and cable programming is available for your entertainment. Private bathrooms with shower/tub combinations feature complimentary toiletries and hair dryers.</p>
                                        <p>Dining : Enjoy Indian cuisine at The Clay Oven Restaurant, a restaurant which features a bar/lounge, or stay in and take advantage of the 24-hour room service. Continental breakfasts are available daily for a fee.</p>
                                        <p>Special Instructions : This property offers transfers from the airport (surcharges may apply). Guests must contact the property with arrival details before travel, using the contact information on the booking confirmation. To make arrangements for check-in please contact the property ahead of time using the information on the booking confirmation. If you are planning to arrive after noon please contact the property in advance using the information on the booking confirmation. Guests must contact the property in advance for check-in instructions. Front desk staff will greet guests on arrival. To register at this property, guests who are Indian citizens must provide a valid photo identity card issued by the Government of India; travelers who are not citizens of India must present a valid passport and visa.</p>


                                        <h3 className='sub_heading'>Amenities</h3>
                                        <div class="row">
                                            <div class="col-md-4 col-sm-6"> Elevator</div>
                                            <div class="col-md-4 col-sm-6"> Luggage storage</div>
                                            <div class="col-md-4 col-sm-6"> Free valet parking</div>
                                            <div class="col-md-4 col-sm-6"> Free self parking</div>
                                            <div class="col-md-4 col-sm-6"> Snack bar/deli</div>
                                            <div class="col-md-4 col-sm-6"> Terrace</div>
                                            <div class="col-md-4 col-sm-6"> Lockers available</div>
                                            <div class="col-md-4 col-sm-6"> Number of bars/lounges - 1</div>
                                            <div class="col-md-4 col-sm-6"> Number of meeting rooms - 1</div>
                                            <div class="col-md-4 col-sm-6"> Free newspapers in lobby</div>
                                            <div class="col-md-4 col-sm-6"> 24-hour front desk</div>
                                            <div class="col-md-4 col-sm-6"> Business center</div>
                                            <div class="col-md-4 col-sm-6"> Express check-out</div>
                                            <div class="col-md-4 col-sm-6"> Dry cleaning/laundry service</div>
                                            <div class="col-md-4 col-sm-6"> Tours/ticket assistance</div>
                                            <div class="col-md-4 col-sm-6"> Free WiFi</div>
                                            <div class="col-md-4 col-sm-6"> Express check-in</div>
                                            <div class="col-md-4 col-sm-6"> Smoke-free property</div>
                                            <div class="col-md-4 col-sm-6"> Laundry facilities</div>
                                            <div class="col-md-4 col-sm-6"> Airport transportation (surcharge)</div>
                                            <div class="col-md-4 col-sm-6"> Concierge services</div>
                                            <div class="col-md-4 col-sm-6"> ATM/banking</div>
                                            <div class="col-md-4 col-sm-6"> Breakfast available (surcharge)</div>
                                            <div class="col-md-4 col-sm-6"> Coffee/tea in common areas</div>
                                        </div>


                                    </div>


                                </div>
                            </div>




                        </div>


                    </div>
                </div>
            </div>
        </>

    )
};

export default Results;
